/**
 * LazyImage component with native lazy loading and blur-up effect
 */
export default function LazyImage({ 
  src, 
  alt, 
  className = "", 
  width,
  height,
  ...props 
}) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={width}
      height={height}
      className={className}
      {...props}
    />
  );
}
